import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CustomInput from "../../../../../Component/DigitalMarketing/CustomInput";
import useHandleChangeHooks from "../../../../../hooks/digitalMarketing/useHandleChangeHooks";
import CustomVioletButton from "../../../../../Component/DigitalMarketing/CustomVioletButton";
import { useCreateProgressNotesHistoryMutation } from "../../../../../Service/PatientList";
import useSnackbar from "../../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../../Component/DigitalMarketing/Toast";

const AddProgressNotes = (props: any) => {
  const { setProgressNotesModal, onSuccess } = props;
  const location = useLocation();
  const { id } = useParams();
  const { consultantId } = location.state || {};
  const { open, message, openSnackBar, type } = useSnackbar();

  const { formData, setFormData, handleChange, submit, setSubmit } =
    useHandleChangeHooks({});

  const [addProgressNotes, { isLoading }] = useCreateProgressNotesHistoryMutation();

  const handleSubmit = async () => {
    setSubmit(true);

    if (!formData.report || !formData.notes) {
      toast.error("Please fill all required fields");
      return;
    }

    const postformData = new FormData();
    // ✅ backend expects file as "report"
    postformData.append("report", formData.report);
    postformData.append("notes", formData.notes);
    postformData.append("consultantId", consultantId);
    postformData.append("customerId", id!);

    try {
      const res = await addProgressNotes(postformData).unwrap();
      openSnackBar(res?.message);

      setTimeout(() => {
        setProgressNotesModal(false);
        if (onSuccess) onSuccess();
      }, 500);
    } catch (err: any) {
      openSnackBar(
        err?.data?.message ||
          err?.data?.error ||
          "Failed to add progress notes",
        "error"
      );
    }
  };

  return (
    <div>
      <Toast open={open} type={type} message={message} />

      {/* File Upload */}
      <CustomInput
        type="file"
        submit={submit}
        {...formData}
        name="report"
        value=""
        onChange={handleChange}
        setFormData={setFormData}
      />

      {/* Notes Field */}
      <CustomInput
        {...formData}
        onChange={handleChange}
        type="textarea"
        label="Notes"
        validation="required"
        submit={submit}
        name="notes"
        setFormData={setFormData}
      />

      <div className="mt-3 d-flex justify-content-end">
        <CustomVioletButton
          btnLabel="Add Progress Note"
          onClick={handleSubmit}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default AddProgressNotes;
